<template>
  <div class="dictation-comparison">
    <div class="aligned-words" lang="en">
      <span v-for="(word, index) in grade.alignment" :key="index" :class="['aligned-word', word.status]">
        <span class="word-label">{{ $t(`levelTest.wordStatus.${word.status}`) }}</span>
        <span v-if="word.status === 'wrong' || word.status === 'spelling'" class="typed-word"><s>{{ word.typed }}</s> → {{ word.expected }}</span>
        <span v-else-if="word.status === 'extra'"><s>{{ word.typed }}</s></span>
        <span v-else>{{ word.expected }}</span>
      </span>
    </div>
    <p class="comparison-score">{{ $t('levelTest.dictationCompactScore', { accuracy: grade.accuracy }) }}</p>
  </div>
</template>

<script>
export default {
  name: 'DictationComparison',
  props: { grade: { type: Object, required: true } }
}
</script>

<style scoped>
.dictation-comparison { margin-top: var(--space-4); }
.comparison-hint, .comparison-score { color: var(--ink-secondary); font-size: var(--font-size-xs); line-height: 1.6; }
.aligned-words { display: flex; flex-wrap: wrap; align-items: flex-end; gap: var(--space-2); margin-top: var(--space-3); }
.aligned-word { display: inline-flex; flex-direction: column; gap: var(--space-1); padding: var(--space-2); border-radius: var(--radius-sm); background: var(--surface-subtle); color: var(--ink-primary); font-size: var(--font-size-sm); }
.word-label { font-size: var(--font-size-xs); font-family: var(--font-family-base); }
.correct .word-label { display: none; }
.wrong, .extra { background: var(--color-danger-bg); color: var(--color-danger); }
.missing, .spelling { background: var(--color-warning-bg); color: var(--color-warning-text); }
.comparison-score { margin-top: var(--space-3); }
</style>
